export default __webpack_public_path__ + "static/media/IMG_7555.46daf3bc.jpeg";